<!-- Breadcrumb-->
<div class="row pt-2 pb-2">
	<div class="col-sm-9">
		<h4 class="page-title">Masks</h4>
		<ol class="breadcrumb">
			<li class="breadcrumb-item"><a href="javaScript:;">Bulona</a>
			</li>
			<li class="breadcrumb-item"><a href="javaScript:;">Forms</a>
			</li>
			<li class="breadcrumb-item active" aria-current="page">Masks</li>
		</ol>
	</div>
	<div class="col-sm-3">
		<div ngbDropdown class="btn-group float-sm-right">
			<button type="button" class="btn btn-outline-danger"><i class="fa fa-cog mr-1"></i> Setting</button>
			<button type="button" class="btn btn-danger" id="dropdownBasic5" ngbDropdownToggle> <span class="caret"></span>
			</button>
			<div ngbDropdownMenu aria-labelledby="dropdownBasic5"> 
				<a href="javaScript:;" ngbDropdownItem>Action</a>
				<a href="javaScript:;" ngbDropdownItem>Another action</a>
				<a href="javaScript:;" ngbDropdownItem>Something else here</a>
				<div class="dropdown-divider"></div> 
				<a href="javaScript:;" ngbDropdownItem>Separated link</a>
			</div>
		</div>
	</div>
</div>
<!-- End Breadcrumb-->
<div class="card">
	<div class="card-header text-uppercase">Input text masks</div>
	<div class="card-body">
		<div class="form-group row" *ngFor="let choice of choices">
			<label class="col-2 col-form-label">{{choice.name}}</label>
			<div class="col-10">
				<input class="form-control" type="text" placeholder="{{choice.placeholder}}" [textMask]="{mask: choice.mask}">
			</div>
		</div>
	</div>
</div>